<template>
    <div class="main-container-page" v-if="!showDailyPriceModal">
        <div class="d-flex justify-content-between">
            <h2 class="first-header heading-large"><i class="fas fa-chart-line mr-2"></i>Active Offers</h2>
        </div>
        <div class="row">
          <div class="col-8"><service-tab/></div>
          <div class="col-4" v-if="isSpotTab && getIsOrderCaptureEnabledForUser">  
            <el-select 
              class="float-right mr-1" 
              v-model="customer" 
              clearable 
              placeholder="Select Customer" 
              value-key="id"
              style="width: 100%">
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
              <template #empty>No matching customer</template>
            </el-select>
          </div>
        </div>
        <component :is="getThisComponent" :selectedCustomer="selectedCustomer" class="card border-radius-top-left-0" />
    </div>
</template>

<script>

import { mapGetters, mapState } from 'vuex'

import ContractsTable from './ContractsTable.vue'
import SpotTable from './SpotTable.vue'
import DeliveredInTable from './DeliveredInTable.vue'
import RefreshInformation from '@/components/RefreshInformation.vue';
import ServiceTab from './ServiceTab.vue'

export default {
    data:() => ({
      customer: {}
    }),
    components:{
        ServiceTab,
        ContractsTable,
        SpotTable,
        RefreshInformation,
        DeliveredInTable
    },
    computed:{
      ...mapGetters('login', ['getIsOrderCaptureEnabledForUser']),
      ...mapGetters('sellerDashboard',['isContractsTab', 'isSpotTab', 'isDeliveredInTab']),
      ...mapGetters('accounts',['customerList']),
      ...mapState('livePrices',['showDailyPriceModal', 'refreshSecondsLeft']),
      getThisComponent() {
        if(this.isSpotTab) {
          return "spot-table";
        }
        if(this.isContractsTab) {
          return "contracts-table";
        }
        if(this.isDeliveredInTab) {
          return "delivered-in-table";
        }
          return null;
      },
      selectedCustomer:{
        get: function(){
          if(this.customer !== ''){
            return this.customer;
          }
          return {};
        }
      }
    }
}
</script>
